import type {FilterEntityIdSet} from '../../../types/filter-entity-id-set'
import type {ShopState} from './state'
import {SET_FILTER_ENTITIES, SET_SHOP} from './mutation-types'
import type {Shop} from './types'

export default {
  [SET_FILTER_ENTITIES]: (state: ShopState, value: FilterEntityIdSet) => {
    state.filterEntityIds = Object.entries(value).reduce(
      (idLists, entry) => {
        return {
          ...idLists,
          [entry[0]]: entry[1]
            .filter(entityHasProductConfigurations)
            .map(entity => entity.id)}
      },
      {}
    )
  },
  [SET_SHOP]: (state: ShopState, value: Shop) => {
    state.shopConfig = value.config
  }
}

function entityHasProductConfigurations (entity) {
  if ('nrOfProductConfigurations' in entity) {
    return entity.nrOfProductConfigurations > 0
  }
  if ('nrOfProductConfigurationsAsFromStop' in entity && 'nrOfProductConfigurationsAsToStop' in entity) {
    return entity.nrOfProductConfigurationsAsFromStop > 0 || entity.nrOfProductConfigurationsAsToStop > 0
  }

  throw new Error('Invalid entity: ' + JSON.stringify(entity))
}



// WEBPACK FOOTER //
// ./src/store/modules/shop/mutations.js